export default "__VITE_ASSET__05HkP5Ap__"